import React from 'react';
import { Accordion } from '@naf-simba/elements-accordion';
import { PortableTextBlock } from '@portabletext/react';
import BlockContent from '../../../BlockContent';
import * as S from './Accordion.styles';

interface AccordionSerializerProps {
  value: { text: PortableTextBlock[]; title: string };
}

export const AccordionBlock = ({ value: { text, title } }: AccordionSerializerProps) => (
  <Accordion headingLevel={3} title={title} className="accordion">
    <S.AccordionContent>
      <BlockContent value={text} />
    </S.AccordionContent>
  </Accordion>
);
